import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import etchedCrab from '../../assets/gifs/ETCH_CRAB.gif';
import etchedBadgeThing from '../../assets/gifs/ETCH_BADGE_THING.gif';
import etchedBag from '../../assets/gifs/ETCH_BAG.gif';
import { Image, Shape, Slogan } from '../common';
import './HomeIllustrations.scss';

const HomeIllustrationsTemplate = (props) => {
  const { illustrations } = props;
  const {
    etchedMaracas,
    etchedSun,
  } = illustrations;
  return (
    <div className="home-illustrations">
      <div className="illustrations-row illustrations-row-top">
        <div className="illustration illustration-maracas">
          <div className="maracas-wrapper">
            <Image
              image={{ localFile: etchedMaracas }}
              className="contain"
            />
          </div>
        </div>
        <Shape
          shapeName="petal"
          shapeColour="#EEEA00"
        />
        <div className="illustration illustration-badge-thing">
          <img src={etchedBadgeThing} alt="Badge thing" />
        </div>
        <div className="illustration illustration-shape illustration-vessel">
          <Shape
            shapeName="vessel"
            shapeColour="#00BC74"
          />
        </div>
        <div className="illustration  illustration-crab">
          <img src={etchedCrab} alt="Crab" />
        </div>
      </div>
      <div className="illustrations-row illustrations-row-middle">
        <div className="illustration illustration-sun">
          <div className="mobile-shape-petal">
            <Shape
              shapeName="petal"
              shapeColour="#EEEA00"
            />
          </div>
          <div className="image-container">
            <Image
              image={{ localFile: etchedSun }}
              className="contain"
            />
          </div>
        </div>
        <div className="illustration-placeholder illustration-placeholder-left" />
        <div className="illustration-placeholder illustration-placeholder-right" />
        <div className="illustration illustration-bag">
          <img src={etchedBag} alt="Bag" />
        </div>
        <div className="illustration illustration-shape illustration-arc">
          <Shape
            shapeName="arc"
            shapeColour="#00BEE0"
          />
        </div>
      </div>
      <div className="illustrations-row illustrations-row-bottom">
        <div className="shape-group">
          <div className="illustration illustration-shape">
            <Shape
              shapeName="pebbles"
              shapeColour="#2FCF00"
            />
          </div>
          <div className="illustration illustration-shape">
            <Shape
              shapeName="mountain"
              shapeColour="#0A85E5"
            />
          </div>
          <div className="illustration illustration-shape">
            <Shape
              shapeName="flower"
              shapeColour="#FF7636"
            />
          </div>
        </div>
        <div className="illustration illustration-slogan">
          <Slogan />
        </div>
        <div className="illustration illustration-shape illustration-square">
          <Shape
            shapeName="square"
            shapeColour="#007307"
          />
        </div>
      </div>
    </div>
  );
};

const HomeIllustrations = props => (
  <StaticQuery
    query={graphql`
      query {
        etchedBag: file(relativePath: { eq: "assets/images/etched/ETCH_BAG_ONE.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        etchedMaracas: file(relativePath: { eq: "assets/images/etched/ETCH_MARACAS.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        etchedSun: file(relativePath: { eq: "assets/images/etched/ETCH_SUN.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `}
    render={data => <HomeIllustrationsTemplate illustrations={data} {...props} />}
  />
);

export default HomeIllustrations;
